// Vendors
import styled from 'styled-components';
// Styles
import { HeaderLayoutContentFullHeightStyled } from 'styles/app.styled';

const AppInformationComponentStyled = styled(HeaderLayoutContentFullHeightStyled)<{
  fetching: boolean;
}>`
  height: ${({ fetching }) =>
    fetching ? `calc(100vh - ${({ theme }) => theme.spacing_500})` : '100%'};
`;
AppInformationComponentStyled.displayName = 'AppInformationComponentStyled';

export { AppInformationComponentStyled };
